export default __webpack_public_path__ + "static/media/cliente07_color.b8619311.png";